/**
 * Пути приложения. Строками они разъезжаются: `/my-robots/12` в одном месте и
 * `/myrobots/12` в другом дают белый экран, который ловится только руками.
 */
export const ROUTES = {
  home: "/",

  robots: "/robots",
  robotsCompare: "/robots/compare",
  robot: (id: number | string) => `/robots/${id}`,
  robotBuy: (id: number | string) => `/robots/${id}/buy`,
  robotBuyConfirm: (id: number | string) => `/robots/${id}/buy/confirm`,
  robotBuySuccess: (id: number | string) => `/robots/${id}/buy/success`,

  myRobots: "/my-robots",
  myRobot: (id: number | string) => `/my-robots/${id}`,

  wallet: "/wallet",
  depositAsset: "/wallet/deposit",
  depositNetwork: "/wallet/deposit/network",
  depositAmount: "/wallet/deposit/amount",
  deposit: (id: number | string) => `/wallet/deposit/${id}`,
  transactions: "/wallet/transactions",

  withdrawAmount: "/wallet/withdraw",
  withdrawAddress: "/wallet/withdraw/address",
  withdrawConfirm: "/wallet/withdraw/confirm",
  withdrawal: (id: number | string) => `/wallet/withdraw/${id}`,

  rating: "/rating",

  activity: "/activity",
  notifications: "/activity/notifications",
  activityItem: (id: number | string) => `/activity/${id}`,

  profile: "/profile",
  profileEdit: "/profile/edit",
  profileNotifications: "/profile/notifications",
  profileLanguage: "/profile/language",
  profilePrivacy: "/profile/privacy",
  referral: "/profile/referral",
  support: "/profile/support",
  legal: (slug: string) => `/legal/${slug}`,

  blocked: "/blocked",
} as const;

/**
 * Корни вкладок. На них Telegram-кнопка «назад» скрыта: уходить из корня
 * некуда, а показанная кнопка выбрасывала бы из приложения.
 */
export const TAB_ROOTS: readonly string[] = [
  ROUTES.home,
  ROUTES.robots,
  ROUTES.depositAsset,
  ROUTES.activity,
  ROUTES.profile,
];
